import { FC, ReactElement } from 'react'
import { Link } from 'react-router-dom'

import { ASSETS } from '../../../constants'
import { useI18n } from '../../../hooks'
import { useAppSelector } from '../../../store'
import { ProductWithVariants } from '../../../types'
import { escapeSpecialRegExCharacters, getAmountWithCurrency, random } from '../../../utils'
import Image from '../../atoms/images/image'

import './index.css'

type SearchBarProductCardProps = {
  product: ProductWithVariants
  searchQuery: string
  togglePopUp: () => void
}

const SearchBarProductCard: FC<SearchBarProductCardProps> = ({ product, searchQuery, togglePopUp }): ReactElement => {
  const { t } = useI18n()
  const { settings } = useAppSelector((state) => state.appConfigReducer)
  const toPath = `/products/${product.productId}`
  const getHighlightedText = (text: string, highlight: string) => {
    const parts = text.split(new RegExp(`(${escapeSpecialRegExCharacters(highlight.trim()).replaceAll(' ', '|')})`, 'gi'))
    return (
      <>
        {parts.map((part, i) =>
          highlight.toLowerCase().includes(part.toLowerCase()) ? (
            <b key={part + i} className="highlightedText heavy">
              {part}
            </b>
          ) : (
            part
          )
        )}
      </>
    )
  }
  return (
    <div className="search-result-column">
      <Link
        to={{
          pathname: toPath,
          state: {
            path: `/shop`,
            search: `?search=${encodeURIComponent(searchQuery)}`,
            productName: product.name,
            locationPath: toPath,
          },
        }}
        onClick={togglePopUp}
        className="search-result-link-column"
        title={product.name}
        style={{ textDecoration: 'none' }}
      >
        {product.mediaUrls ? (
          <Image
            src={product.mediaUrls[0]?.url || `${ASSETS}/default/products/Mobile_${random(4, 1)}.jpg`}
            size={{ width: '80px', height: '80px' }}
            sizeType="card"
            alt={(product.mediaUrls[0]?.alt as string) || 'On The Hub Logo'}
          />
        ) : null}
        <div className="search-result-card-content">
          <div className="product-name-header">{getHighlightedText(product.name, searchQuery)}</div>
          <div className="product-price-container">
            <div className="low-price-container">
              <span className="product-start-price-label">{t('Common_startingFrom')}</span>
              <span className="product-low-price heavy">
                {product.asLowAs.price
                  ? `${getAmountWithCurrency(settings.locale.language, product.asLowAs.currencyType, product.asLowAs.price)}`
                  : t('Common_free')}
              </span>
              {!!product.asLowAs.msrp && (
                <div className="product-msrp-price">
                  <span className="for-screen-reader">{t('Common_oldPrice')}: </span>
                  <div>
                    {getAmountWithCurrency(settings.locale.language, product.asLowAs.currencyType, Number(product.asLowAs.msrp.toFixed(2)))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default SearchBarProductCard
